module.exports = __webpack_public_path__ + "img/discount-right.d17951cf.svg";